import { useTheme, type ThemePreference } from '@/lib/theme';
import { Card } from '@/components/ui';

/** Light, dark, or follow the device. */
export function AccountAppearancePage() {
  return <Appearance />;
}

const THEME_OPTIONS: Array<{ value: ThemePreference; label: string; hint: string }> = [
  { value: 'system', label: 'System', hint: 'Match your device' },
  { value: 'light', label: 'Light', hint: 'Always light' },
  { value: 'dark', label: 'Dark', hint: 'Always dark' },
];

function Appearance() {
  const { preference, setPreference } = useTheme();
  return (
    <Card title="Appearance">
      <div role="radiogroup" aria-label="Theme" className="grid gap-3 sm:grid-cols-3">
        {THEME_OPTIONS.map((o) => (
          <button
            key={o.value}
            type="button"
            role="radio"
            aria-checked={preference === o.value}
            onClick={() => setPreference(o.value)}
            className={`rounded-lg border px-4 py-3 text-left text-sm transition-colors ${
              preference === o.value
                ? 'border-primary bg-primary/10'
                : 'border-border hover:bg-muted'
            }`}
          >
            <span className="block font-medium">{o.label}</span>
            <span className="block text-muted-foreground">{o.hint}</span>
          </button>
        ))}
      </div>
    </Card>
  );
}
